"use strict";

/* ============================================================
   ABR SUIT DESIGNER — data
   ============================================================ */
const BASE_PRICE = 495;

const FABRICS = [
  { id: "sage-wool",    name: "Sage Wool",         color: "#67775a", category: "Trending", pattern: "none",        price: 45 },
  { id: "champagne",    name: "Champagne",         color: "#d4bd85", category: "Formal",   pattern: "none",        price: 55 },
  { id: "burnt-sienna", name: "Burnt Sienna",      color: "#b05a2a", category: "Trending", pattern: "none",        price: 50 },
  { id: "navy-twill",   name: "Navy Twill",        color: "#2b3a55", category: "Business", pattern: "none",        price: 0 },
  { id: "charcoal",     name: "Charcoal Wool",     color: "#36393f", category: "Business", pattern: "none",        price: 20 },
  { id: "midnight",     name: "Midnight Tux",      color: "#15161c", category: "Formal",   pattern: "none",        price: 60 },
  { id: "slate-stripe", name: "Slate Pinstripe",   color: "#3a4356", category: "Business", pattern: "stripe",      price: 40 },
  { id: "grey-check",   name: "Grey Glen Check",   color: "#777a7e", category: "Casual",   pattern: "check",       price: 45 },
  { id: "olive",        name: "Olive Linen",       color: "#5f6446", category: "Casual",   pattern: "none",        price: 30 },
  { id: "tan",          name: "Tan Cotton",        color: "#b69877", category: "Casual",   pattern: "none",        price: 25 },
  { id: "burgundy",     name: "Burgundy Velvet",   color: "#5c2230", category: "Formal",   pattern: "none",        price: 80 },
  { id: "lt-blue",      name: "Sky Sharkskin",     color: "#5a7da3", category: "Business", pattern: "dot",         price: 35 },
  { id: "brown-herr",   name: "Brown Herringbone", color: "#6b5644", category: "Casual",   pattern: "herringbone", price: 50 },
  { id: "pink",         name: "Blush Windowpane",  color: "#e0a9b6", category: "Casual",   pattern: "check",       price: 35 },
];

const STYLE_GROUPS = [
  {
    key: "jacket", title: "Jacket style", default: "single",
    options: [
      { id: "single", name: "Single-breasted", icon: "▯", price: 0 },
      { id: "double", name: "Double-breasted", icon: "▰", price: 25 },
    ],
  },
  {
    key: "lapel", title: "Lapel style", default: "notch",
    options: [
      { id: "notch", name: "Notch", icon: "◣", price: 0 },
      { id: "peak",  name: "Peak",  icon: "◤", price: 15 },
      { id: "shawl", name: "Shawl", icon: "◠", price: 25 },
    ],
  },
  {
    key: "buttons", title: "Button count", default: "2",
    options: [
      { id: "1", name: "1 Button",  icon: "•",   price: 0 },
      { id: "2", name: "2 Buttons", icon: "••",  price: 0 },
      { id: "3", name: "3 Buttons", icon: "•••", price: 10 },
    ],
  },
  {
    key: "pockets", title: "Pocket style", default: "flap",
    options: [
      { id: "flap",   name: "Flap",   icon: "▭", price: 0 },
      { id: "jetted", name: "Jetted", icon: "—", price: 10 },
      { id: "patch",  name: "Patch",  icon: "▢", price: 15 },
    ],
  },
  {
    key: "vents", title: "Vents", default: "side",
    options: [
      { id: "none",   name: "None",   icon: "│", price: 0 },
      { id: "center", name: "Center", icon: "╎", price: 0 },
      { id: "side",   name: "Side",   icon: "‖", price: 10 },
    ],
  },
  {
    key: "lining", title: "Lining color", default: "burnt", type: "color",
    options: [
      { id: "burnt",    name: "Burnt Orange", color: "#9a4419", price: 0 },
      { id: "sage",     name: "Sage",         color: "#8a9a7b", price: 0 },
      { id: "gold",     name: "Gold",         color: "#c2a14d", price: 10 },
      { id: "burgundy", name: "Burgundy",     color: "#7d2230", price: 0 },
      { id: "royal",    name: "Royal",        color: "#1f3a93", price: 0 },
      { id: "black",    name: "Black",        color: "#222222", price: 0 },
    ],
  },
];

const FITS = [
  { id: "slim",     name: "Slim",     icon: "▮", price: 0 },
  { id: "tailored", name: "Tailored", icon: "▯", price: 0 },
  { id: "classic",  name: "Classic",  icon: "▭", price: 0 },
];

const MONOGRAM_PRICE = 15;

/* ============================================================
   STATE
   ============================================================ */
const state = {
  step: 0,
  view: "photo",
  fabric: null,
  jacket: "single",
  lapel: "notch",
  buttons: "2",
  pockets: "flap",
  vents: "side",
  lining: "burnt",
  fit: "tailored",
  fabricFilter: "All",
  measureMode: "body",
  monogram: "",
};

const $ = (sel) => document.querySelector(sel);
const $$ = (sel) => Array.from(document.querySelectorAll(sel));
const money = (n) => "$" + n.toLocaleString("en-US");
const configEl = document.getElementById("configurator");

/* Fabric → AI model photo map (from #fabric-photos JSON in the template) */
let PHOTOS = {};
(function () {
  const el = document.getElementById("fabric-photos");
  if (el) { try { PHOTOS = JSON.parse(el.textContent); } catch (e) { PHOTOS = {}; } }
})();

/* Merge the store's full fabric library (swatch-image fabrics, unlimited).
   Each entry: {id, name, category, price, image} — the image is tiled onto the suit. */
(function () {
  const el = document.getElementById("fabric-library");
  if (!el) return;
  try {
    const lib = JSON.parse(el.textContent);
    lib.forEach(function (f) {
      if (f && f.id && f.image && !FABRICS.some(function (x) { return x.id === f.id; })) {
        FABRICS.push({
          id: f.id, name: f.name || f.id, color: f.color || "#6b705c",
          category: f.category || "Library", pattern: "none",
          price: Number(f.price) || 0, image: f.image,
        });
      }
    });
  } catch (e) { /* malformed library JSON — ignore */ }
})();

function getFabric() {
  return state.fabric ? FABRICS.find(function (f) { return f.id === state.fabric; }) : null;
}

/* Customer swatch upload → becomes a selectable fabric, tiled on the form */
function addCustomFabric(dataUrl, name) {
  const existing = FABRICS.find(function (f) { return f.id === "custom-upload"; });
  if (existing) {
    existing.image = dataUrl;
    existing.name = name || existing.name;
  } else {
    FABRICS.unshift({ id: "custom-upload", name: name || "Your Fabric", color: "#8a8f84", category: "Custom", pattern: "none", price: 0, image: dataUrl });
  }
  state.fabric = "custom-upload";
  state.view = "photo";
  renderFabricFilters();
  renderFabricGrid();
  renderSuit();
  syncPrice();
  syncPreviewMeta();
}
window.ABRDesigner = { addCustomFabric: addCustomFabric };

/* ============================================================
   MODEL RECOLOR ENGINE
   Detects the suit region in the base model photo once (hue key),
   then re-drapes it in any fabric color — real folds and shadows
   preserved — and blends the actual swatch texture on top.
   ============================================================ */
const Recolor = {
  status: "idle", // idle | loading | ready | failed
  w: 0, h: 0, base: null, mask: null, avgL: 0.42, queue: [],
};

function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = ((g - b) / d + (g < b ? 6 : 0));
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return [h, s, l];
}

function hslToRgb(h, s, l) {
  h = ((h % 360) + 360) % 360 / 360;
  function hue(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  if (s === 0) { const v = Math.round(l * 255); return [v, v, v]; }
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  return [Math.round(hue(p, q, h + 1 / 3) * 255), Math.round(hue(p, q, h) * 255), Math.round(hue(p, q, h - 1 / 3) * 255)];
}

function hexToRgb(hex) {
  const m = String(hex).replace("#", "");
  return [parseInt(m.substr(0, 2), 16), parseInt(m.substr(2, 2), 16), parseInt(m.substr(4, 2), 16)];
}

function recolorInit(done) {
  if (Recolor.status === "ready") return done(true);
  if (Recolor.status === "failed") return done(false);
  Recolor.queue.push(done);
  if (Recolor.status === "loading") return;
  Recolor.status = "loading";

  const src = PHOTOS["sage-wool"];
  if (!src) { Recolor.status = "failed"; flushRecolorQueue(false); return; }
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = function () {
    try {
      const scale = Math.min(1, 860 / img.naturalWidth);
      Recolor.w = Math.round(img.naturalWidth * scale);
      Recolor.h = Math.round(img.naturalHeight * scale);
      const c = document.createElement("canvas");
      c.width = Recolor.w; c.height = Recolor.h;
      const ctx = c.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, Recolor.w, Recolor.h);
      Recolor.base = ctx.getImageData(0, 0, Recolor.w, Recolor.h);
      // Build the suit mask: sage hue band, moderate saturation
      const d = Recolor.base.data;
      const w = Recolor.w, h = Recolor.h;
      let mask = new Float32Array(w * h);
      let sumL = 0, count = 0;
      for (let i = 0, p = 0; i < d.length; i += 4, p++) {
        // The model stands center-frame — corners are always background
        const px = (p % w) / w, py = Math.floor(p / w) / h;
        if (px < 0.24 || px > 0.80 || py < 0.16) continue;
        const hsl = rgbToHsl(d[i], d[i + 1], d[i + 2]);
        // Measured from the base photo: the suit is dark muted olive
        // (h 37–90, s ≤ .38, l ≤ .55); background, floor shadow, skin and tie
        // are warmer (h < 37), lighter, or more saturated.
        if (hsl[0] >= 37 && hsl[0] <= 90 && hsl[1] >= 0.04 && hsl[1] <= 0.38 && hsl[2] >= 0.015 && hsl[2] <= 0.55) {
          mask[p] = 1; sumL += hsl[2]; count++;
        }
      }
      // Soften: blur the mask so weave shadows inside the suit are filled
      // and edges feather instead of speckling.
      function boxBlur(src) {
        const tmp = new Float32Array(w * h);
        const dst = new Float32Array(w * h);
        const r = 2, div = r * 2 + 1;
        for (let y = 0; y < h; y++) {
          let acc = 0;
          const row = y * w;
          for (let x = -r; x <= r; x++) acc += src[row + Math.min(w - 1, Math.max(0, x))];
          for (let x = 0; x < w; x++) {
            tmp[row + x] = acc / div;
            acc += src[row + Math.min(w - 1, x + r + 1)] - src[row + Math.max(0, x - r)];
          }
        }
        for (let x = 0; x < w; x++) {
          let acc = 0;
          for (let y = -r; y <= r; y++) acc += tmp[Math.min(h - 1, Math.max(0, y)) * w + x];
          for (let y = 0; y < h; y++) {
            dst[y * w + x] = acc / div;
            acc += tmp[Math.min(h - 1, y + r + 1) * w + x] - tmp[Math.max(0, y - r) * w + x];
          }
        }
        return dst;
      }
      mask = boxBlur(boxBlur(mask));
      // Push interior back to full strength; keep soft edges
      for (let p = 0; p < mask.length; p++) mask[p] = Math.min(1, mask[p] * 1.7);
      Recolor.mask = mask;
      Recolor.avgL = count ? sumL / count : 0.42;
      Recolor.status = "ready";
      flushRecolorQueue(true);
    } catch (e) {
      Recolor.status = "failed";
      flushRecolorQueue(false);
    }
  };
  img.onerror = function () { Recolor.status = "failed"; flushRecolorQueue(false); };
  img.src = src;
}

function flushRecolorQueue(ok) {
  Recolor.queue.splice(0).forEach(function (cb) { cb(ok); });
}

function fabricAvgColor(fabric, done) {
  if (fabric._avg) return done(fabric._avg);
  if (!fabric.image) { fabric._avg = hexToRgb(fabric.color); return done(fabric._avg); }
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = function () {
    try {
      const c = document.createElement("canvas");
      c.width = 8; c.height = 8;
      const ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, 8, 8);
      const d = ctx.getImageData(0, 0, 8, 8).data;
      let r = 0, g = 0, b = 0;
      for (let i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }
      fabric._avg = [Math.round(r / 64), Math.round(g / 64), Math.round(b / 64)];
    } catch (e) { fabric._avg = hexToRgb(fabric.color); }
    done(fabric._avg);
  };
  img.onerror = function () { fabric._avg = hexToRgb(fabric.color); done(fabric._avg); };
  img.src = fabric.image;
}

function recolorDraw(fabric) {
  const canvas = document.getElementById("model-canvas");
  if (!canvas || Recolor.status !== "ready") return;
  canvas.width = Recolor.w; canvas.height = Recolor.h;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });

  fabricAvgColor(fabric, function (rgb) {
    const t = rgbToHsl(rgb[0], rgb[1], rgb[2]);
    const th = t[0], ts = Math.min(t[1], 0.85), tl = t[2];
    const src = Recolor.base.data, mask = Recolor.mask;
    const out = ctx.createImageData(Recolor.w, Recolor.h);
    const od = out.data;
    const lGain = Math.max(0.15, Math.min(2.2, tl / Recolor.avgL));
    for (let i = 0, p = 0; i < src.length; i += 4, p++) {
      const a = mask[p];
      if (a > 0.03) {
        const hsl = rgbToHsl(src[i], src[i + 1], src[i + 2]);
        const nl = Math.max(0.02, Math.min(0.97, hsl[2] * lGain));
        const c2 = hslToRgb(th, ts, nl);
        od[i] = Math.round(c2[0] * a + src[i] * (1 - a));
        od[i + 1] = Math.round(c2[1] * a + src[i + 1] * (1 - a));
        od[i + 2] = Math.round(c2[2] * a + src[i + 2] * (1 - a));
      } else {
        od[i] = src[i]; od[i + 1] = src[i + 1]; od[i + 2] = src[i + 2];
      }
      od[i + 3] = src[i + 3];
    }
    ctx.putImageData(out, 0, 0);

    // Blend the real swatch weave over the recolored suit
    if (fabric.image) {
      const tex = new Image();
      tex.crossOrigin = "anonymous";
      tex.onload = function () {
        try {
          const before = ctx.getImageData(0, 0, Recolor.w, Recolor.h);
          const pc = document.createElement("canvas");
          pc.width = 110; pc.height = 110;
          pc.getContext("2d").drawImage(tex, 0, 0, 110, 110);
          ctx.globalCompositeOperation = "multiply";
          ctx.globalAlpha = 0.35;
          ctx.fillStyle = ctx.createPattern(pc, "repeat");
          ctx.fillRect(0, 0, Recolor.w, Recolor.h);
          ctx.globalCompositeOperation = "source-over";
          ctx.globalAlpha = 1;
          const blended = ctx.getImageData(0, 0, Recolor.w, Recolor.h);
          const bd = blended.data, pd = before.data;
          for (let i = 0, p = 0; i < bd.length; i += 4, p++) {
            const a = Recolor.mask[p];
            if (a < 0.97) {
              bd[i] = Math.round(bd[i] * a + pd[i] * (1 - a));
              bd[i + 1] = Math.round(bd[i + 1] * a + pd[i + 1] * (1 - a));
              bd[i + 2] = Math.round(bd[i + 2] * a + pd[i + 2] * (1 - a));
            }
          }
          ctx.putImageData(blended, 0, 0);
        } catch (e) { /* texture blend optional */ }
      };
      tex.src = fabric.image;
    }
  });
}

function updatePreviewView() {
  const photoWrap = $("#preview-photo");
  const stage = document.querySelector(".preview-stage");
  const tabs = $$("#preview-tabs .pv-tab");
  const note = $("#pv-note");
  const img = $("#preview-photo-img");
  const canvas = document.getElementById("model-canvas");
  if (!photoWrap || !stage) return;

  const showPhoto = state.view === "photo";
  tabs.forEach(function (t) { t.classList.toggle("active", t.dataset.view === state.view); });
  photoWrap.classList.toggle("hidden", !showPhoto);
  stage.classList.toggle("hidden", showPhoto);
  if (!showPhoto) return;

  const f = getFabric();
  const exact = f ? PHOTOS[f.id] : PHOTOS["sage-wool"];

  if (exact || !f) {
    // We have a real AI photo for this fabric — use it
    img.src = exact || PHOTOS["sage-wool"];
    img.classList.remove("hidden");
    if (canvas) canvas.classList.add("hidden");
    note.classList.add("hidden");
    return;
  }

  // No exact photo: re-drape the base model in this fabric
  recolorInit(function (ok) {
    if (ok && canvas) {
      recolorDraw(f);
      canvas.classList.remove("hidden");
      img.classList.add("hidden");
      note.classList.add("hidden");
    } else {
      // Engine unavailable — fall back to the form view
      state.view = "sketch";
      photoWrap.classList.add("hidden");
      stage.classList.remove("hidden");
      tabs.forEach(function (t) { t.classList.toggle("active", t.dataset.view === "sketch"); });
    }
  });
}

function findOpt(groupKey, id) {
  const g = STYLE_GROUPS.find((x) => x.key === groupKey);
  return g.options.find((o) => o.id === id);
}

/* ============================================================
   PRICE
   ============================================================ */
function computePrice() {
  let total = BASE_PRICE;
  if (state.fabric) total += FABRICS.find((f) => f.id === state.fabric).price;
  total += findOpt("jacket", state.jacket).price;
  total += findOpt("lapel", state.lapel).price;
  total += findOpt("buttons", state.buttons).price;
  total += findOpt("pockets", state.pockets).price;
  total += findOpt("vents", state.vents).price;
  total += findOpt("lining", state.lining).price;
  if (state.monogram.trim()) total += MONOGRAM_PRICE;
  return total;
}

function priceBreakdown() {
  const rows = [{ label: "Base custom suit", amount: BASE_PRICE }];
  if (state.fabric) {
    const f = FABRICS.find((x) => x.id === state.fabric);
    rows.push({ label: "Fabric — " + f.name, amount: f.price });
  }
  [["jacket", "Jacket"], ["lapel", "Lapel"], ["buttons", "Buttons"], ["pockets", "Pockets"], ["vents", "Vents"], ["lining", "Lining"]].forEach(
    function (pair) {
      const o = findOpt(pair[0], state[pair[0]]);
      if (o.price > 0) rows.push({ label: pair[1] + " — " + o.name, amount: o.price });
    }
  );
  if (state.monogram.trim()) rows.push({ label: 'Monogram "' + state.monogram.toUpperCase() + '"', amount: MONOGRAM_PRICE });
  return rows;
}

/* ============================================================
   SVG PREVIEW
   ============================================================ */
const LAPEL_PATHS = {
  notch: {
    left:  "M150 110 L120 175 L150 168 L170 200 L200 150 Z",
    right: "M250 110 L280 175 L250 168 L230 200 L200 150 Z",
  },
  peak: {
    left:  "M150 110 L112 168 L150 160 L138 132 L172 196 L200 150 Z",
    right: "M250 110 L288 168 L250 160 L262 132 L228 196 L200 150 Z",
  },
  shawl: {
    left:  "M150 110 Q120 150 140 205 L172 200 L200 150 Z",
    right: "M250 110 Q280 150 260 205 L228 200 L200 150 Z",
  },
};

const PATTERN_MARKS = {
  none: "",
  stripe: '<line x1="4" y1="0" x2="4" y2="20" stroke="rgba(255,255,255,0.18)" stroke-width="1.5"/><line x1="14" y1="0" x2="14" y2="20" stroke="rgba(255,255,255,0.18)" stroke-width="1.5"/>',
  check: '<path d="M0 5 H20 M0 15 H20 M5 0 V20 M15 0 V20" stroke="rgba(255,255,255,0.16)" stroke-width="1"/>',
  dot: '<circle cx="5" cy="5" r="1.3" fill="rgba(255,255,255,0.22)"/><circle cx="15" cy="15" r="1.3" fill="rgba(255,255,255,0.22)"/>',
  herringbone: '<path d="M0 10 L5 5 L10 10 L15 5 L20 10" stroke="rgba(255,255,255,0.16)" stroke-width="1" fill="none"/>',
};

function renderSuit() {
  const f = getFabric();
  const fabricImg = document.getElementById("fabric-image");
  const pattern = document.getElementById("fabric-pattern");
  if (f) {
    configEl.style.setProperty("--cfg-fabric", f.color);
    if (f.image && fabricImg && pattern) {
      // Tile the real swatch image across the suit
      fabricImg.setAttribute("href", f.image);
      fabricImg.setAttribute("xlink:href", f.image);
      fabricImg.style.display = "";
      pattern.setAttribute("width", "90");
      pattern.setAttribute("height", "90");
      $("#pattern-marks").innerHTML = "";
    } else {
      if (fabricImg) fabricImg.style.display = "none";
      if (pattern) { pattern.setAttribute("width", "20"); pattern.setAttribute("height", "20"); }
      $("#pattern-marks").innerHTML = PATTERN_MARKS[f.pattern] || "";
    }
  }

  const lining = findOpt("lining", state.lining);
  configEl.style.setProperty("--cfg-lining", lining.color);
  const reveal = state.fabric ? 0.9 : 0;
  $("#lining-left").setAttribute("opacity", reveal);
  $("#lining-right").setAttribute("opacity", reveal);

  const lp = LAPEL_PATHS[state.lapel];
  $("#lapel-left").setAttribute("d", lp.left);
  $("#lapel-right").setAttribute("d", lp.right);

  let btnHtml = "";
  if (state.jacket === "double") {
    // Double-breasted: two columns of three
    for (let i = 0; i < 3; i++) {
      btnHtml += '<circle cx="186" cy="' + (225 + i * 38) + '" r="5" fill="#2b2e27" stroke="rgba(255,255,255,0.25)" stroke-width="0.6"/>';
      btnHtml += '<circle cx="214" cy="' + (225 + i * 38) + '" r="5" fill="#2b2e27" stroke="rgba(255,255,255,0.25)" stroke-width="0.6"/>';
    }
  } else {
    const count = parseInt(state.buttons, 10);
    const startY = count === 1 ? 250 : 215;
    for (let i = 0; i < count; i++) {
      btnHtml += '<circle cx="200" cy="' + (startY + i * 40) + '" r="5" fill="#2b2e27" stroke="rgba(255,255,255,0.25)" stroke-width="0.6"/>';
    }
  }
  $("#buttons").innerHTML = btnHtml;
  $("#pockets").innerHTML = renderPockets(state.pockets);
  $("#monogram-text").textContent = state.monogram.toUpperCase();

  updatePreviewView();
}

function renderPockets(style) {
  const lower = [{ x: 95, y: 380 }, { x: 245, y: 380 }];
  let html = '<line x1="235" y1="210" x2="270" y2="205" stroke="rgba(0,0,0,0.3)" stroke-width="2"/>';
  lower.forEach(function (p) {
    if (style === "flap") {
      html += '<rect x="' + p.x + '" y="' + p.y + '" width="60" height="22" rx="3" fill="rgba(0,0,0,0.10)" stroke="rgba(0,0,0,0.25)" stroke-width="1"/>';
    } else if (style === "jetted") {
      html += '<line x1="' + p.x + '" y1="' + (p.y + 6) + '" x2="' + (p.x + 60) + '" y2="' + (p.y + 6) + '" stroke="rgba(0,0,0,0.3)" stroke-width="2.5"/>';
    } else if (style === "patch") {
      html += '<rect x="' + p.x + '" y="' + (p.y - 4) + '" width="62" height="40" rx="6" fill="rgba(0,0,0,0.06)" stroke="rgba(0,0,0,0.3)" stroke-width="1.5"/>';
    }
  });
  return html;
}

/* ============================================================
   RENDER: STEPS
   ============================================================ */
function renderFabricFilters() {
  const cats = ["All"].concat(Array.from(new Set(FABRICS.map(function (f) { return f.category; }))));
  $("#fabric-filters").innerHTML = cats
    .map(function (c) {
      return '<button class="filter-chip ' + (c === state.fabricFilter ? "active" : "") + '" data-filter="' + c + '">' + c + "</button>";
    })
    .join("");
}

function renderFabricGrid() {
  const list = FABRICS.filter(function (f) {
    return state.fabricFilter === "All" || f.category === state.fabricFilter;
  });
  $("#fabric-grid").innerHTML = list
    .map(function (f) {
      const extra = f.price ? "+" + money(f.price) : "Included";
      const bg = f.image
        ? "background-image:url('" + f.image + "')"
        : "background:" + f.color;
      return (
        '<button class="swatch ' + (state.fabric === f.id ? "selected" : "") + '" data-fabric="' + f.id + '">' +
        '<div class="swatch-color" style="' + bg + '"><span class="swatch-check">✓</span></div>' +
        '<div class="swatch-info"><div class="swatch-name">' + f.name + '</div>' +
        '<div class="swatch-meta"><span>' + f.category + "</span><span>" + extra + "</span></div></div></button>"
      );
    })
    .join("");
}

function renderStyleSections() {
  $("#style-sections").innerHTML = STYLE_GROUPS.map(function (g) {
    const cards = g.options
      .map(function (o) {
        const selected = state[g.key] === o.id ? "selected" : "";
        const visual = g.type === "color"
          ? '<div class="color-dot" style="background:' + o.color + '"></div>'
          : '<div class="opt-icon">' + o.icon + "</div>";
        const priceTag = o.price ? "+" + money(o.price) : "Included";
        return (
          '<button class="opt-card ' + selected + '" data-group="' + g.key + '" data-opt="' + o.id + '">' +
          visual + '<div class="opt-name">' + o.name + '</div><div class="opt-price">' + priceTag + "</div></button>"
        );
      })
      .join("");
    return '<div class="opt-group"><div class="opt-group-title">' + g.title + '</div><div class="opt-row">' + cards + "</div></div>";
  }).join("");
}

function renderFitOptions() {
  $("#fit-options").innerHTML = FITS.map(function (f) {
    return (
      '<button class="opt-card ' + (state.fit === f.id ? "selected" : "") + '" data-fit="' + f.id + '">' +
      '<div class="opt-icon">' + f.icon + '</div><div class="opt-name">' + f.name + "</div></button>"
    );
  }).join("");
}

function renderReview() {
  const fabric = state.fabric ? FABRICS.find(function (f) { return f.id === state.fabric; }).name : "—";
  const rows = [
    ["Fabric", fabric],
    ["Jacket", findOpt("jacket", state.jacket).name],
    ["Lapel", findOpt("lapel", state.lapel).name],
    ["Buttons", findOpt("buttons", state.buttons).name],
    ["Pockets", findOpt("pockets", state.pockets).name],
    ["Vents", findOpt("vents", state.vents).name],
    ["Lining", findOpt("lining", state.lining).name],
    ["Fit", FITS.find(function (f) { return f.id === state.fit; }).name],
    ["Measurements", measureSummary()],
    ["Monogram", state.monogram.trim() ? state.monogram.toUpperCase() : "None"],
  ];
  $("#summary").innerHTML = rows
    .map(function (r) {
      return '<div class="summary-row"><span class="label">' + r[0] + '</span><span class="value">' + r[1] + "</span></div>";
    })
    .join("");

  const pb = priceBreakdown();
  $("#price-breakdown").innerHTML =
    pb.map(function (r) {
      return '<div class="pb-row"><span>' + r.label + "</span><span>" + money(r.amount) + "</span></div>";
    }).join("") +
    '<div class="pb-row total"><span>Total</span><span>' + money(computePrice()) + "</span></div>";
}

function measureSummary() {
  if (state.measureMode === "size") {
    const v = $("#m-stdsize").value;
    return v ? "Size " + v : "Not set";
  }
  const h = $("#m-height").value;
  const c = $("#m-chest").value;
  if (h && c) return h + "cm · " + c + "cm chest";
  if (h) return h + "cm";
  return "Not set";
}

function syncPrice() {
  $("#price-value").textContent = money(computePrice());
}

function syncPreviewMeta() {
  if (state.fabric) {
    const f = FABRICS.find(function (x) { return x.id === state.fabric; });
    $("#preview-title").textContent = f.name + " Suit";
    $("#preview-sub").textContent =
      findOpt("lapel", state.lapel).name + " lapel · " +
      findOpt("buttons", state.buttons).name + " · " +
      FITS.find(function (x) { return x.id === state.fit; }).name + " fit";
  } else {
    $("#preview-title").textContent = "Your Custom Suit";
    $("#preview-sub").textContent = "Select a fabric to begin";
  }
}

/* ============================================================
   STEP NAVIGATION
   ============================================================ */
const STEP_COUNT = 4;

function goToStep(n) {
  if (n < 0 || n >= STEP_COUNT) return;
  if (state.step === 0 && n > 0 && !state.fabric) {
    flashFabricRequired();
    return;
  }
  state.step = n;
  updateStepUI();
}

function flashFabricRequired() {
  const sub = $("#preview-sub");
  sub.textContent = "Please choose a fabric first";
  sub.style.color = "#9a4419";
  setTimeout(function () {
    sub.style.color = "";
    syncPreviewMeta();
  }, 1600);
}

function updateStepUI() {
  $$(".step-panel").forEach(function (p) {
    p.classList.toggle("active", Number(p.dataset.panel) === state.step);
  });
  $$(".stepper .step").forEach(function (s) {
    const n = Number(s.dataset.step);
    s.classList.toggle("active", n === state.step);
    s.classList.toggle("done", n < state.step);
  });

  $("#btn-back").disabled = state.step === 0;
  const next = $("#btn-next");
  if (state.step === STEP_COUNT - 1) {
    next.style.visibility = "hidden";
  } else {
    next.style.visibility = "visible";
    next.textContent = state.step === STEP_COUNT - 2 ? "Review order" : "Continue";
  }

  if (state.step === 3) renderReview();
  configEl.scrollIntoView({ behavior: "smooth", block: "start" });
}

/* ============================================================
   SHOPIFY CART
   ============================================================ */
function orderProperties() {
  const props = {
    Fabric: state.fabric ? FABRICS.find(function (f) { return f.id === state.fabric; }).name : "",
    Jacket: findOpt("jacket", state.jacket).name,
    Lapel: findOpt("lapel", state.lapel).name,
    Buttons: findOpt("buttons", state.buttons).name,
    Pockets: findOpt("pockets", state.pockets).name,
    Vents: findOpt("vents", state.vents).name,
    Lining: findOpt("lining", state.lining).name,
    Fit: FITS.find(function (f) { return f.id === state.fit; }).name,
    Measurements: measureSummary(),
    "Estimated Total": money(computePrice()),
  };
  if (state.monogram.trim()) props.Monogram = state.monogram.toUpperCase();
  ["m-height", "m-weight", "m-chest", "m-waist", "m-hips"].forEach(function (id) {
    const el = document.getElementById(id);
    if (el && el.value) {
      const label = id.replace("m-", "");
      props[label.charAt(0).toUpperCase() + label.slice(1) + " (cm/kg)"] = el.value;
    }
  });
  return props;
}

function addToCart() {
  const btn = $("#add-cart");
  const confirmEl = $("#cart-confirm");
  const variantId = configEl.dataset.variantId;

  if (!variantId) {
    // No "custom-suit" product configured — route the design to the contact page instead.
    try {
      sessionStorage.setItem("abr-suit-design", JSON.stringify(orderProperties()));
    } catch (e) { /* private mode */ }
    confirmEl.classList.remove("hidden");
    confirmEl.textContent = "Taking you to booking — your design details come with you.";
    window.location.href = configEl.dataset.contactUrl || "/pages/contact";
    return;
  }

  btn.disabled = true;
  btn.textContent = "Adding…";
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: orderProperties() }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error("Cart error");
      return res.json();
    })
    .then(function () {
      btn.textContent = "Added ✓";
      confirmEl.classList.remove("hidden");
      confirmEl.innerHTML = 'Added to cart — <a href="/cart">view your cart</a> or keep browsing.';
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = "Add to Cart";
      confirmEl.classList.remove("hidden");
      confirmEl.textContent = "Something went wrong — please call (336) 404-3957 and we'll take it from here.";
    });
}

/* ============================================================
   EVENTS + INIT
   ============================================================ */
function bindEvents() {
  const tabs = $("#preview-tabs");
  if (tabs) {
    tabs.addEventListener("click", function (e) {
      const tab = e.target.closest(".pv-tab");
      if (!tab) return;
      state.view = tab.dataset.view;
      updatePreviewView();
    });
  }

  $("#stepper").addEventListener("click", function (e) {
    const step = e.target.closest(".step");
    if (step) goToStep(Number(step.dataset.step));
  });
  $("#btn-back").addEventListener("click", function () { goToStep(state.step - 1); });
  $("#btn-next").addEventListener("click", function () { goToStep(state.step + 1); });

  $("#fabric-filters").addEventListener("click", function (e) {
    const chip = e.target.closest(".filter-chip");
    if (!chip) return;
    state.fabricFilter = chip.dataset.filter;
    renderFabricFilters();
    renderFabricGrid();
  });
  $("#fabric-grid").addEventListener("click", function (e) {
    const sw = e.target.closest(".swatch");
    if (!sw) return;
    state.fabric = sw.dataset.fabric;
    // Every fabric shows on the model — exact photo when we have one, live re-drape otherwise
    state.view = "photo";
    renderFabricGrid();
    renderSuit();
    syncPrice();
    syncPreviewMeta();
  });

  const fileInput = document.getElementById("fabric-file");
  if (fileInput) {
    fileInput.addEventListener("change", function (e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = function () {
        addCustomFabric(reader.result, file.name.replace(/\.[^.]+$/, "").slice(0, 24) || "Your Fabric");
      };
      reader.readAsDataURL(file);
    });
  }

  $("#style-sections").addEventListener("click", function (e) {
    const card = e.target.closest(".opt-card");
    if (!card) return;
    state[card.dataset.group] = card.dataset.opt;
    renderStyleSections();
    renderSuit();
    syncPrice();
    syncPreviewMeta();
  });

  $("#fit-options").addEventListener("click", function (e) {
    const card = e.target.closest(".opt-card");
    if (!card) return;
    state.fit = card.dataset.fit;
    renderFitOptions();
    syncPreviewMeta();
  });

  $$('input[name="measure-mode"]').forEach(function (r) {
    r.addEventListener("change", function (e) {
      state.measureMode = e.target.value;
      $("#measure-body").classList.toggle("hidden", state.measureMode !== "body");
      $("#measure-size").classList.toggle("hidden", state.measureMode !== "size");
    });
  });

  $("#monogram-input").addEventListener("input", function (e) {
    state.monogram = e.target.value.replace(/[^a-zA-Z]/g, "").slice(0, 3);
    e.target.value = state.monogram.toUpperCase();
    renderSuit();
    syncPrice();
  });

  $("#add-cart").addEventListener("click", addToCart);
}

function init() {
  if (!configEl) return;
  renderFabricFilters();
  renderFabricGrid();
  renderStyleSections();
  renderFitOptions();
  renderSuit();
  syncPrice();
  syncPreviewMeta();
  bindEvents();
  updateStepUI();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
